<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="user-do-dialog"
  >
    <div class="form-content">
      <user-form
        ref="outform"
        @submit="submit"
      ></user-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import userForm from "@/components/sys/userList/userForm";
import { addUser } from "@/api/sys/userList";

export default {
  name: "addUserDialog",
  components: {
    userForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let treeIds= [];
      let formRef = this.$refs.outform;
      if(formRef.$refs.menuListTree.getCheckedKeys()){
        formRef.$refs.menuListTree.getCheckedNodes().forEach(item => {
          if(item.nodeValue){
            treeIds.push(item.id)
          }
        });
      }


      let params = {
        'username': form.userName,
        'password': form.password,
        'salt': form.salt,
        'email': form.email,
        'mobile': form.mobile,
        'status': form.status,
        'roleIdList': form.roleId,
        'treeIds':treeIds
      }
      addUser(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '操作成功',
            type: 'success',
          });
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
        
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .user-do-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
